// extracted by mini-css-extract-plugin
export var header = "section-header-module--header--1740c";